import avatar from '../../studio/assets/activity_icon.png';
import noimage from '../../studio/assets/graphics_grey_icon.png';
import { CardType, QuestionType, ResourceType } from '../../graphql/api';

export const isUrl = (url: string): boolean => {
  return /[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&/=]*)/.test(
    url
  );
};

export const mockupData = {
  activity: {
    bold: 'Lorem Ipsum',
    text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.  Nullam lectus justo, vulputate eget mollis sed, tempor sed magna.',
    type: CardType.activity,
  },
  definition: {
    term: 'Lorem Ipsum',
    text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.  Nullam lectus justo, vulputate eget mollis sed, tempor sed magna.',
    type: CardType.definition,
  },
  highlight: {
    text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.  Nullam lectus justo, vulputate eget mollis sed, tempor sed magna. Praesent vitae arcu tempor neque lacinia pretium.',
    type: CardType.highlight,
  },
  resource: {
    context:
      'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.  Nullam lectus justo, vulputate eget mollis sed, tempor sed magna.',
    resourceType: ResourceType.article,
    source: 'Resource card',
    title: 'Lorem Ipsum',
    type: CardType.resource,
    url: 'https://hbr.org/2018/05/agile-at-scale',
  },
  video: {
    context:
      'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.  Nullam lectus justo, vulputate eget mollis sed, tempor sed magna.',
    source: 'Video card',
    title: 'Lorem Ipsum',
    type: CardType.video,
    url: 'https://hbr.org/2018/05/agile-at-scale',
  },
  list: {
    listItems: [
      'Lorem ipsum Item 1',
      'Lorem ipsum Item 2',
      'Lorem ipsum Item 3',
      'Lorem ipsum Item 4',
      'Lorem ipsum Item 5',
    ],
    numbered: false,
    title: 'Lorem Ipsum List',
    type: CardType.list,
  },
  quote: {
    affiliation: 'Title',
    author: 'Author Name',
    text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit.  Nullam lectus justo, vulputate eget mollis sed.',
    type: CardType.quote,
  },
  factoid: {
    text: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit',
    type: CardType.factoid,
  },
  profile: {
    type: CardType.profile,
    expertise: 'title or expertise',
    firstName: 'First',
    lastName: 'Last',
    avatarPath: avatar,
    twitter: 'https://twitter.com',
    linkedin: 'https://linkedin.com',
  },
  graphic: {
    caption: 'Lorem ipsum dolor sit amet, consectetuer adipiscing elit',
    type: CardType.graphic,
    url: noimage,
  },
  quiz: {
    type: CardType.quiz,
    question: 'Lorem ipsum?',
    questionType: QuestionType.multipleChoiceSingleResponse,
    answerDetails: {
      __typename: 'AnswerDetails' as any,
      answerOptions: [
        {
          __typename: 'AnswerOption' as any,
          index: 0,
          sortOrder: 0,
          text: 'Lorem',
        },
        {
          __typename: 'AnswerOption' as any,
          index: 1,
          sortOrder: 0,
          text: 'Ipsum',
        },
      ],
    },
  },
  poll: {
    type: CardType.poll,
    question: 'Lorem ipsum?',
    answerDetails: {
      __typename: 'AnswerDetails' as any,
      answerOptions: [
        {
          __typename: 'AnswerOption' as any,
          index: 0,
          sortOrder: 0,
          text: 'Lorem',
        },
        {
          __typename: 'AnswerOption' as any,
          index: 1,
          sortOrder: 0,
          text: 'Ipsum',
        },
      ],
    },
  },
  text: {
    text: 'Hello world',
    type: CardType.text,
    title: 'Text',
  },
};
